import { GET_MASTER_CONFIGS, GET_MASTER_CONFIGS_EMPTY, GET_MASTER_CONFIGS_ERROR, GET_MASTER_CONFIGS_SUCCESS } from '../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetMasterConfigs = (state = initialState, action) => {
  switch (action.type) {
    case GET_MASTER_CONFIGS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_MASTER_CONFIGS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_MASTER_CONFIGS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_MASTER_CONFIGS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetMasterConfigs;
